var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheckBroken({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.47715 6.47715 2 12 2C13.5671 2 15.0527 2.3612 16.3756 3.00582C16.872 3.24775 17.0784 3.84635 16.8364 4.34282C16.5945 4.8393 15.9959 5.04564 15.4994 4.80371C14.4436 4.28918 13.257 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM20.0196 5.66789C20.4101 6.05842 20.4101 6.69158 20.0196 7.08211L12.1446 14.9571C11.7541 15.3476 11.1209 15.3476 10.7304 14.9571L8.48039 12.7071C8.08987 12.3166 8.08987 11.6834 8.48039 11.2929C8.87092 10.9024 9.50408 10.9024 9.89461 11.2929L11.4375 12.8358L18.6054 5.66789C18.9959 5.27737 19.6291 5.27737 20.0196 5.66789Z",
    fill: "#118462"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckBroken);
export default __webpack_public_path__ + "static/media/ic-check-broken.375dd4cb9fefcee61daac774d6ea98b4.svg";
export { ForwardRef as ReactComponent };